module.exports = __webpack_public_path__ + "img/bp-red.17570f42.png";